import { render, staticRenderFns } from "./MembersItemLocation.vue?vue&type=template&id=0f63d657&"
import script from "./MembersItemLocation.vue?vue&type=script&lang=js&"
export * from "./MembersItemLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports